<script lang="ts">
  import { page } from "@inertiajs/svelte"
  import type { Snippet } from "svelte"
  import { locale } from "svelte-i18n"

  import { Toaster } from "@/components/ui/sonner"
  import { useDesktop } from "@/runes/use-desktop.svelte"
  import { useFlash } from "@/runes/use-flash.svelte"

  interface Props {
    children: Snippet
  }

  let { children }: Props = $props()

  useFlash()

  // Below the desktop layout the navigation is pinned to the bottom of the
  // screen, and a toast down there would sit on it for its few seconds.
  const desktop = useDesktop()

  // i18n is bootstrapped in the entrypoints (entrypoints/inertia.ts and
  // ssr/ssr.ts); this only follows locale changes across navigations. A
  // not-yet-loaded locale is fetched by its registered loader, with English
  // shown until it arrives.
  $effect(() => {
    const railsLocale = page.props.locale as string | undefined
    if (railsLocale) void locale.set(railsLocale)
  })
</script>

{@render children()}
<Toaster
  richColors
  position={desktop.matches ? "bottom-right" : "top-center"}
  mobileOffset={{ top: "calc(env(safe-area-inset-top) + 0.5rem)" }}
/>
